import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";

export default function Page7t() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let nezamhayeKeifiat;
    if (JSON.parse(localStorage?.data)?.[jobId]?.nezamhayeKeifiat) {
        nezamhayeKeifiat = JSON.parse(localStorage?.data)?.[jobId]?.nezamhayeKeifiat
    } else {
        nezamhayeKeifiat = [];
    }


    let ghavaninVaMoghararat;
    if (JSON.parse(localStorage?.data)?.[jobId]?.ghavaninVaMoghararat) {
        ghavaninVaMoghararat = JSON.parse(localStorage?.data)?.[jobId]?.ghavaninVaMoghararat
    } else {
        ghavaninVaMoghararat = [];
    }
    return (
        <Page pageNumber={11}>
            <div className="font-bold text-lg">
                اهم استانداردها و نظام‌های کیفیت مورد نیاز:
            </div>
            <div className="relative">
                <div className="flex flex-col w-full pl-4">
                    <div className="w-full h-[80px] bg-green-300 text-black flex items-center p-4">تسلط</div>
                    <div className="w-full h-[80px] bg-green-200 text-black flex items-center p-4">توانایی</div>
                    <div className="w-full h-[80px] bg-green-100 text-black flex items-center p-4">آشنایی</div>
                </div>
                <div className="flex flex-col">
                    <div className="absolute top-[30px] left-0">- 3</div>
                    <div className="absolute top-[110px] left-0">- 2</div>
                    <div className="absolute top-[190px] left-[4px]">- 1</div>
                    <div className="w-full pl-4">
                        <div className="w-full h-[2px] bg-gray-400"></div>
                    </div>
                    <div className="h-[240px] w-[2px] bg-gray-400 absolute left-[15px] top-0"></div>
                </div>
                <div className="flex gap-2 absolute -bottom-[22px] left-[25px]">
                    {
                        Object.keys(nezamhayeKeifiat).map((key, index) => {

                            if (nezamhayeKeifiat[key].value >= 3) {
                                let height = 0;
                                nezamhayeKeifiat[key].value == 3 ? height = 40 : nezamhayeKeifiat[key].value == 4 ? height = 120 : height = 200
                                return (
                                    <div className="flex flex-col gap-2 items-center justify-end w-[45px]">
                                        <div className="w-[15px] bg-green-700 relative rounded-t" style={{ height: `${height}px` }}>
                                            {/* <span className="absolute -top-[15px] -left-[7px] text-3xl text-red-600">x</span> */}
                                        </div>
                                        <div className="w-[50px] text-xs -rotate-45 -ml-14" style={{ whiteSpace: "nowrap", transformOrigin: "100% 0%" }}>{key}</div>
                                    </div>
                                )
                            }
                        })
                    }

                </div>
            </div>
            <div className="font-bold text-lg mt-10">
                استانداردها و نظام‌های کیفیت مورد نیاز:
            </div>
            <div className="flex flex-wrap gap-2">
                {Object.keys(nezamhayeKeifiat).map((key, index) => {
                    if (nezamhayeKeifiat[key].value >= 2) {

                        return (<span className="odd-color bg-gray-300 rounded p-2" key={index}>{key}</span>)
                    }
                })}
            </div>
            <div className="font-bold text-lg mt-20">
                اهم قوانین و مقررات مورد نیاز:
            </div>
            <div className="relative">
                <div className="flex flex-col w-full pl-4">
                    <div className="w-full h-[80px] bg-orange-300 text-black flex items-center p-4">تسلط</div>
                    <div className="w-full h-[80px] bg-orange-200 text-black flex items-center p-4">توانایی</div>
                    <div className="w-full h-[80px] bg-orange-100 text-black flex items-center p-4">آشنایی</div>
                </div>
                <div className="flex flex-col">
                    <div className="absolute top-[30px] left-0">- 3</div>
                    <div className="absolute top-[110px] left-0">- 2</div>
                    <div className="absolute top-[190px] left-[4px]">- 1</div>
                    <div className="w-full pl-4">
                        <div className="w-full h-[2px] bg-gray-400"></div>
                    </div>
                    <div className="h-[240px] w-[2px] bg-gray-400 absolute left-[15px] top-0"></div>
                </div>
                <div className="flex gap-2 absolute -bottom-[22px] left-[25px]">
                    {
                        Object.keys(ghavaninVaMoghararat).map((key, index) => {

                            if (ghavaninVaMoghararat[key].value >= 3) {
                                let height = 0;
                                ghavaninVaMoghararat[key].value == 3 ? height = 40 : ghavaninVaMoghararat[key].value == 4 ? height = 120 : height = 200
                                return (
                                    <div className="flex flex-col gap-2 items-center justify-end w-[45px]">
                                        <div className="w-[15px] bg-orange-700 relative rounded-t" style={{ height: `${height}px` }}>
                                            {/* <span className="absolute -top-[15px] -left-[7px] text-3xl text-red-600">x</span> */}
                                        </div>
                                        <div className="w-[50px] text-xs -rotate-45 -ml-14" style={{ whiteSpace: "nowrap", transformOrigin: "100% 0%" }}>{key}</div>
                                    </div>
                                )
                            }
                        })
                    }

                </div>
            </div>
            <div className="font-bold text-lg mt-10">
                قوانین و مقررات مورد نیاز:
            </div>
            <div className="flex flex-wrap gap-2">
                {Object.keys(ghavaninVaMoghararat).map((key, index) => {
                    if (ghavaninVaMoghararat[key].value >= 2) {

                        return (<span className="odd-color bg-gray-300 rounded p-2" key={index}>{key}</span>)
                    }
                })}
            </div>
        </Page>
    )
}